import React from 'react';
import { Box, Typography, Stack, Rating } from '@mui/material';
import { styled } from '@mui/material/styles';
import TestimonialCard from './TestimonialCard';

const SectionContainer = styled(Box)(({ theme }) => ({
  padding: '80px 315px',
  backgroundColor: '#ffffff',
  [theme.breakpoints.down('lg')]: {
    padding: '60px 80px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '40px 20px'
  }
}));

const SectionHeader = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: '60px',
  gap: '20px'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Nunito, sans-serif',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '18.20px',
  textTransform: 'uppercase',
  color: '#565969'
}));

const SectionHeading = styled(Typography)(({ theme }) => ({
  fontFamily: 'Kumbh Sans, sans-serif',
  fontSize: '57px',
  fontWeight: 700,
  letterSpacing: '-1.10px',
  lineHeight: '60px',
  color: '#0d2b23',
  [theme.breakpoints.down('md')]: {
    fontSize: '40px',
    lineHeight: '45px'
  }
}));

const TestimonialsGrid = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '40px',
  justifyContent: 'center',
  flexWrap: 'wrap',
  [theme.breakpoints.down('lg')]: {
    gap: '20px'
  }
}));

const RatingWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
  marginTop: '10px'
}));

const RatingScore = styled(Typography)(({ theme }) => ({
  fontFamily: 'Kumbh Sans, sans-serif',
  fontSize: '24px',
  fontWeight: 700,
  color: '#0d2b23'
}));

const RatingCount = styled(Typography)(({ theme }) => ({
  fontFamily: 'Nunito, sans-serif',
  fontSize: '14px',
  color: '#565969'
}));

const TestimonialsSection = ({ testimonials = [], businessInfo }) => {
  // Calculate rating if not provided in businessInfo
  const rating = businessInfo?.rating ||
    (testimonials.length > 0 ? (testimonials.reduce((acc, t) => acc + (t.rating || 5), 0) / testimonials.length).toFixed(1) : '5.0');

  const reviewCount = businessInfo?.reviewCount || testimonials.length;

  return (
    <SectionContainer>
      <SectionHeader>
        <SectionTitle>testimonials</SectionTitle>
        <SectionHeading>What Client's say about</SectionHeading>

        <RatingWrapper>
          <RatingScore>{rating}</RatingScore>
          <Rating value={Number(rating)} precision={0.1} readOnly />
          <RatingCount>({reviewCount} Reviews)</RatingCount>
        </RatingWrapper>
      </SectionHeader>

      <TestimonialsGrid>
        {testimonials.map((testimonial) => (
          <TestimonialCard key={testimonial.id} testimonial={testimonial} />
        ))}
      </TestimonialsGrid>
    </SectionContainer>
  );
};

export default TestimonialsSection;